import React, { useState } from 'react';
import StringValueBuilderInput from '../StringValueBuilderInput';
import EnumInput from '../../../../../misc/EnumInput';
import * as DeviceTypes from './GoogleDeviceTypes';
import { Card, CardHeader, Button, Collapse, CardBody, FormGroup} from 'reactstrap';
import BoolInput from '../../../../../misc/BoolInput';
import { useTranslation } from 'react-i18next';
import { CoreGoogleDeviceOrganizationalUnitSettings, GoogleDeviceOrganizationalUnitSource, GoogleDeviceOUOperator, CoreOrganizationalUnitPath } from '../../../../../../models/CoreGoogleDeviceExportModels';
import { StringValueBuilderPartValueSource } from '../../../../../../models/CoreModels';
import GoogleDeviceOU from './GoogleDeviceOU';
import {
    defaultStringValueBuilderPartDefinitions,
    pickStringValueBuilderDefinitions
} from '../StringValueBuilderDefinitions';


export const googleDeviceStringValueBuilderPartDefinitions = pickStringValueBuilderDefinitions(
    defaultStringValueBuilderPartDefinitions,
    [
        StringValueBuilderPartValueSource.CLASS,
        StringValueBuilderPartValueSource.STAGE,
        StringValueBuilderPartValueSource.FORMOFEDUCATION,  
        StringValueBuilderPartValueSource.PRIMARYSCHOOL,
        StringValueBuilderPartValueSource.STUDENT_SCHOOL_YEAR,
        StringValueBuilderPartValueSource.CONSTANT
    ]
);
interface GoogleDeviceOrganizationalUnitSettingsProps {
    organizationalUnitSettings: CoreGoogleDeviceOrganizationalUnitSettings
    disabled?: boolean
    validation: string[]
    onChange: (x: CoreGoogleDeviceOrganizationalUnitSettings) => void
}

const defaultIgnoredPath: CoreOrganizationalUnitPath = {
    operator: GoogleDeviceOUOperator.StartsWith,
    path: ''
};
const GoogleDeviceOrganizationalUnitSettings: React.FC<GoogleDeviceOrganizationalUnitSettingsProps> = (props) => {
    const [isOpen, setOpen] = useState<boolean>(true);
    const { t } = useTranslation(['configuration', 'common'])
    const updateConfig = (change: Partial<CoreGoogleDeviceOrganizationalUnitSettings>) => {
        props.onChange({ ...props.organizationalUnitSettings, ...change })
    }

    return (<Card className="mb-3">
        <CardHeader>
            <Button outline color="secondary" style={{ width: '37px', float: 'right' }} onClick={() => setOpen(!isOpen)}>{isOpen ? '-' : '+'}</Button>
            {t('googleDeviceExport.ouSettings.ouHeader', { ns: 'configuration' })}
        </CardHeader>
        <Collapse isOpen={isOpen}>
            <CardBody>
            <FormGroup> 
                <h5>{t('googleDeviceExport.ouSettings.organizationalUnitSource.title', { ns: 'configuration' })} </h5>
                <EnumInput
                    title={t('googleDeviceExport.ouSettings.organizationalUnitSource.subTitle1', { ns: 'configuration' })}
                    titleSmall={true}
                    name='organizationalUnitSettings.organizationalUnitSource'
                    value={props.organizationalUnitSettings.organizationalUnitSource}
                    options={DeviceTypes.OrganizationalUnitPathSources.filter(key => key === GoogleDeviceOrganizationalUnitSource.RecentUser).map(key => ({
                        value: key,
                        text: t(`googleDeviceExport.ouSettings.organizationalUnitSource.sourceOptions.${key}`, { ns: 'configuration' })
                    }))}
                    onChange={(_, value) => updateConfig({ organizationalUnitSource: value })}
                    disabled={props.disabled}
                    invalid={props.validation.indexOf('organizationalUnitSource') !== -1}
                    invalidFeedback={t('googleDeviceExport.ouSettings.organizationalUnitSource.invalidFeedback', { ns: 'configuration' })}
                />
                <EnumInput
                    title={t('googleDeviceExport.ouSettings.organizationalUnitSource.subTitle', { ns: 'configuration' })}
                    titleSmall={true}
                    name='organizationalUnitSettings.organizationalUnitSource'
                    value={props.organizationalUnitSettings.organizationalUnitSource}
                    options={DeviceTypes.OrganizationalUnitPathSources.filter(key => key !== GoogleDeviceOrganizationalUnitSource.RecentUser && key !== GoogleDeviceOrganizationalUnitSource.None).map(key => ({
                        value: key,
                        text: t(`googleDeviceExport.ouSettings.organizationalUnitSource.sourceOptions.${key}`, { ns: 'configuration' })
                    }))}
                    onChange={(_, value) => updateConfig({ organizationalUnitSource: value })}
                    disabled={props.disabled}
                    invalid={props.validation.indexOf('organizationalUnitSource') !== -1}
                    invalidFeedback={t('googleDeviceExport.ouSettings.organizationalUnitSource.invalidFeedback', { ns: 'configuration' })}
                />

                {(props.organizationalUnitSettings.organizationalUnitSource === GoogleDeviceOrganizationalUnitSource.ValueBuilder) &&
                    <StringValueBuilderInput
                        name='organizationalUnitSettings.stringValueBuilderParts'
                        parts={props.organizationalUnitSettings.stringValueBuilderParts ?? []}
                        onChange={(_, value) => updateConfig({ stringValueBuilderParts: value })}
                        disabled={props.disabled}
                        partDefinitions={googleDeviceStringValueBuilderPartDefinitions}
                        />
                        }
                    {props.validation.indexOf('requiredValueBuilderParts') !== -1 && (
                        <div style={{ display: 'block', color:'red' }}>
                            {t('googleDeviceExport.ouSettings.stringValueBuilderParts.invalidFeedback', { ns: 'configuration' })}
                        </div>)}

                </FormGroup>
                <BoolInput
                    title={t('googleDeviceExport.ouSettings.enableCreateOrganizationalUnit.title', { ns: 'configuration' })}
                    name="organizationalUnitSettings.enableCreateOrganizationalUnit"
                    value={props.organizationalUnitSettings.enableCreateOrganizationalUnit}
                    disabled={props.disabled}
                    updateValue={(_, value) => updateConfig({ enableCreateOrganizationalUnit: value })}
                    invalidFeedback={t('googleDeviceExport.ouSettings.enableCreateOrganizationalUnit.invalidFeedback', { ns: 'configuration' })}
                    invalid={props.validation.indexOf("googleDeviceOrganizationalUnitSettings.enableCreateOrganizationalUnit") !== -1}
                />
                <GoogleDeviceOU
                    onChange={updateConfig}
                    organizationalUnitSettings={props.organizationalUnitSettings}
                    disabled={props.disabled}
                />
            </CardBody>
        </Collapse>
    </Card>);
}

export default GoogleDeviceOrganizationalUnitSettings;